import LifepointsMoreIcon from 'components/assets/colon.svg';
import LifepointsHomeIcon from 'components/assets/lifepoints-nav-home.svg';
import LifepointsSurveyIcon from 'components/assets/message-square.svg';
import MoreMobiIcon from 'components/assets/More-mobi-icon.svg';
import ProfileMobiIcon from 'components/assets/Profile.mobi-icon.svg';
import RewardsMobiIcon from 'components/assets/Rewards-mobi-icon.svg';
import LifepointsRewardsIcon from 'components/assets/star.svg';
import SurveysMobiIcon from 'components/assets/Surveys-mobi-icon.svg';
import QmeeNavIcon from 'components/assets/Qmee-nav-icon.svg';
import QmeeEarn from 'components/assets/Qmee-earn.svg';
import QmeeCashout from 'components/assets/Qmee-cashout.svg';
import QmeeLeagues from 'components/assets/Qmee-leagues.svg';
import QmeeMore from 'components/assets/Qmee-more.svg';
import {
  DASHBOARD,
  MORE,
  PROFILE,
  REWARDS,
  HOME,
  EARN,
  CASHOUT,
  LEAGUES,
  PUBLIC_EARN,
  CASHBACK,
  DEALS,
  GAMING,
  REFER,
  BLOG,
  LEAGUE_PROFILE,
  HOW_LEAGUES_WORK,
} from 'components/pages/pages';
import React from 'react';
import classes from './NavLinks.module.scss';

export interface NavLink {
  label: string;
  href: string;
  icon: React.ReactElement;
  id: string;
  subMenu?: Omit<NavLink, 'icon'>[];
  hasFlatSubPaths?: boolean;
}

export const getQmeeNavLinks = (isLoggedIn: boolean): NavLink[] => [
  {
    id: 'home',
    label: 'Home',
    href: HOME.path,
    icon: <QmeeNavIcon width={21} height={20} className={classes.customBaseColour} />,
  },
  {
    id: 'earn',
    label: 'Earn',
    href: isLoggedIn ? EARN.path : PUBLIC_EARN.path,
    icon: <QmeeEarn width={21} height={21} />,
    hasFlatSubPaths: true,
    subMenu: [
      isLoggedIn
        ? {
            id: 'surveys',
            label: 'Surveys',
            href: EARN.path,
          }
        : {
            id: 'surveys',
            label: 'Surveys',
            href: PUBLIC_EARN.path,
          },
      {
        id: 'cashback',
        label: 'Cashback',
        href: CASHBACK.path,
      },
      {
        id: 'deals',
        label: 'Deals',
        href: DEALS.path,
      },
      {
        id: 'gaming',
        label: 'Gaming',
        href: GAMING.path,
      },
      isLoggedIn
        ? {
            id: 'refer-a-friend',
            label: 'Refer a Friend',
            href: REFER.path,
          }
        : {
            id: 'blog',
            label: 'Blog',
            href: BLOG.path,
          },
    ],
  },
  {
    id: 'cashout',
    label: 'Cashout',
    href: CASHOUT.path,
    icon: <QmeeCashout width={18} height={20} />,
    subMenu: [
      {
        id: 'options',
        label: 'Options',
        href: CASHOUT.path,
      },
      {
        id: 'transactions',
        label: 'Transactions',
        href: CASHOUT.path + '/transactions',
      },
      {
        id: 'insights',
        label: 'Insights',
        href: CASHOUT.path + '/insights',
      },
    ],
  },
  {
    id: 'leagues',
    label: 'Leagues',
    href: LEAGUES.path,
    icon: <QmeeLeagues width={39} height={21} />,
    hasFlatSubPaths: true,
    subMenu: [
      {
        id: 'leaderboard',
        label: 'Leaderboard',
        href: LEAGUES.path,
      },
      {
        id: 'league-profile',
        label: 'League Profile',
        href: LEAGUE_PROFILE.path,
      },
      {
        id: 'how-it-works',
        label: 'How It Works',
        href: HOW_LEAGUES_WORK.path,
      },
    ],
  },
  {
    id: 'more',
    label: 'More',
    href: MORE.path,
    icon: <QmeeMore width={33} height={33} />,
  },
];

export const mobiNavLinks: NavLink[] = [
  {
    id: 'surveys',
    label: 'Surveys',
    href: DASHBOARD.path,
    icon: <SurveysMobiIcon width={33} height={34} />,
  },
  {
    id: 'rewards',
    label: 'Rewards',
    href: REWARDS.path,
    icon: <RewardsMobiIcon width={14} height={29} />,
  },
  {
    id: 'profile',
    label: 'Profile',
    href: PROFILE.path,
    icon: <ProfileMobiIcon width={33} height={32} />,
  },
  {
    id: 'more',
    label: 'More',
    href: MORE.path,
    icon: <MoreMobiIcon width={33} height={33} />,
  },
];

export const lifepointsNavLinks: NavLink[] = [
  {
    id: 'home',
    label: 'Home',
    href: DASHBOARD.path,
    icon: <LifepointsHomeIcon width={22} height={22} />,
  },
  {
    id: 'surveys',
    label: 'Surveys',
    href: DASHBOARD.path,
    icon: <LifepointsSurveyIcon width={22} height={22} />,
  },
  {
    id: 'rewards',
    label: 'Rewards',
    href: REWARDS.path,
    icon: <LifepointsRewardsIcon width={22} height={22} />,
  },
  {
    id: 'more',
    label: 'More',
    href: MORE.path,
    icon: <LifepointsMoreIcon width={22} height={22} />,
  },
];
